import { render, staticRenderFns } from "./left_panel_performance_table.vue?vue&type=template&id=5429f45a&scoped=true"
import script from "./left_panel_performance_table.vue?vue&type=script&lang=js"
export * from "./left_panel_performance_table.vue?vue&type=script&lang=js"
import style0 from "./left_panel_performance_table.vue?vue&type=style&index=0&id=5429f45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5429f45a",
  null
  
)

export default component.exports